import { Flex, Image, RadioButton } from '@bitrise/bitkit';
import React, { useContext, FunctionComponent } from 'react';
import { Route, useParams } from 'react-router-dom';
import dataAtIds from '../../../dataAtIds.json';
import { FeatureContext } from '../../Features/useFeatures';
import { URLStateContext } from '../../URLState/URLState';

import LogoTrace from './LogoTrace.svg';
import LogoSwift from './LogoSwift.svg';
import LogoCocoa from './LogoCocoa.svg';
import LogoGradle from './LogoGradle.svg';

const SetupOptions: FunctionComponent = () => {
  const { hasFeature } = useContext(FeatureContext);
  const { push } = useContext(URLStateContext);
  const { appId } = useParams<{ appId: string }>();

  return (
    <Flex direction="horizontal" gap="x4" margin="x8">
      <Route path="/:appId/o/getting-started/setup/ios">
        {hasFeature('enable-setup-ios-bitrise-step') && (
          <Route path="/:appId/o/getting-started/setup/ios/bitrise-step">
            {({ match }) => (
              <Flex
                alignChildren="middle"
                clickable
                data-trace-at-id={dataAtIds.GettingStartedOptionIosBitriseStep}
                direction="vertical"
                gap="x6"
                grow
                initial="none"
                onClick={() => push(`/${appId}/o/getting-started/setup/ios/bitrise-step`)}
              >
                <Image height="60px" src={LogoTrace} />
                <RadioButton
                  checked={!!match}
                  onChange={() => push(`/${appId}/o/getting-started/setup/ios/bitrise-step`)}
                >
                  Bitrise Workflow Step
                </RadioButton>
              </Flex>
            )}
          </Route>
        )}

        {hasFeature('enable-setup-ios-spm') && (
          <Route path="/:appId/o/getting-started/setup/ios/spm">
            {({ match }) => (
              <Flex
                alignChildren="middle"
                clickable
                data-trace-at-id={dataAtIds.GettingStartedOptionIosSPM}
                direction="vertical"
                gap="x6"
                grow
                initial="none"
                onClick={() => push(`/${appId}/o/getting-started/setup/ios/spm`)}
              >
                <Image height="60px" src={LogoSwift} />
                <RadioButton
                  checked={!!match}
                  onChange={() => push(`/${appId}/o/getting-started/setup/ios/spm`)}
                >
                  Swift Package Manager
                </RadioButton>
              </Flex>
            )}
          </Route>
        )}

        {hasFeature('enable-setup-ios-cocoa-pods') && (
          <Route path="/:appId/o/getting-started/setup/ios/cocoa">
            {({ match }) => (
              <Flex
                alignChildren="middle"
                clickable
                data-trace-at-id={dataAtIds.GettingStartedOptionIosCocoa}
                direction="vertical"
                gap="x6"
                grow
                initial="none"
                onClick={() => push(`/${appId}/o/getting-started/setup/ios/cocoa`)}
              >
                <Image height="60px" src={LogoCocoa} />
                <RadioButton
                  checked={!!match}
                  onChange={() => push(`/${appId}/o/getting-started/setup/ios/cocoa`)}
                >
                  Cocoapods
                </RadioButton>
              </Flex>
            )}
          </Route>
        )}
      </Route>

      <Route path="/:appId/o/getting-started/setup/android">
        {hasFeature('enable-setup-android-bitrise-step') && (
          <Route path="/:appId/o/getting-started/setup/android/bitrise-step">
            {({ match }) => (
              <Flex
                alignChildren="middle"
                clickable
                data-trace-at-id={dataAtIds.GettingStartedOptionAndroidBitriseStep}
                direction="vertical"
                gap="x6"
                grow
                initial="none"
                onClick={() => push(`/${appId}/o/getting-started/setup/android/bitrise-step`)}
              >
                <Image height="60px" src={LogoTrace} />
                <RadioButton
                  checked={!!match}
                  onChange={() => push(`/${appId}/o/getting-started/setup/android/bitrise-step`)}
                >
                  Bitrise Workflow Step
                </RadioButton>
              </Flex>
            )}
          </Route>
        )}

        {hasFeature('enable-setup-android-gradle') && (
          <Route path="/:appId/o/getting-started/setup/android/gradle">
            {({ match }) => (
              <Flex
                alignChildren="middle"
                clickable
                data-trace-at-id={dataAtIds.GettingStartedOptionAndroidGradle}
                direction="vertical"
                gap="x6"
                grow
                initial="none"
                onClick={() => push(`/${appId}/o/getting-started/setup/android/gradle`)}
              >
                <Image height="60px" src={LogoGradle} />
                <RadioButton
                  checked={!!match}
                  onChange={() => push(`/${appId}/o/getting-started/setup/android/gradle`)}
                >
                  Gradle
                </RadioButton>
              </Flex>
            )}
          </Route>
        )}
      </Route>
    </Flex>
  );
};

export default SetupOptions;
